import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Category } from "../types";
import { PlaceholderLoader } from "./placeholder";
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from "swiper/modules";
import { useRef } from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";

interface CategoriesProps {
  categories: Category[];
  loading: boolean
}

const Categories = ({ categories, loading }: CategoriesProps) => {

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  
  return (
    <Container as="section" bsPrefix="bg-light" className="py-5 categories overflow-hidden">
      <Container className="py-5">
        <Container as="div" bsPrefix="z" className="open-up" data-aos="zoom-out">
          <Row>
              {loading ? 
                <div className='row'> {
                  [1,2,3,4].map(e => <div className='col-lg-3'><PlaceholderLoader /></div>) 
                } </div>: 
                (
                  <>
                    {
                      categories.length === 0 && (
                        <div className="text-center">
                          <h5 className='text-uppercase mb-3'>QUALITY POLICY STATEMENT</h5>
                          <p className="mb-2">
                            We, at Easy Sauce Nigeria Limited are committed to aggressively develop manufacture & market OBE Sauce - Hot and Mild products to domestic & export markets by achieving highest level of satisfaction of our interested parties.
                          </p>
                          <p className="mb-2">
                            In our pursuit for continual improvement of our Quality Management System, it is our constant endeavor to ensure compliance to applicable legal & regulatory requirements, which supports company&apos;s strategic direction, appropriate to the purpose and context of the organization and supported by Quality Objectives.
                          </p>
                          <p className="mb-2">
                            This shall be made available to our relevant interested parties.
                          </p>
                          <p className="mb-4">
                            Our Quality Management System performance will be considered at every management meeting and the top management will review this policy annually to ensure that it continues to reflect the aims and aspirations of the company.
                          </p>
                          <p className="fw-semibold">Chief Executive Officer</p>
                        </div>
                      )
                    }
                    {
                      categories.length > 0 && (
                        <>
                        <Swiper
                          modules={[Navigation]}
                          spaceBetween={20}
                          slidesPerView={3}
                          navigation={{
                            nextEl: '.icon-arrow-left',
                            prevEl: '.icon-arrow-right',
                          }}
                          loop={true}
                          onInit={(swiper) => {
                            // @ts-ignore
                            swiper.params.navigation.prevEl = prevRef.current;
                            // @ts-ignore
                            swiper.params.navigation.nextEl = nextRef.current;
                            swiper.navigation.init();
                            swiper.navigation.update();
                          }}
                          onAfterInit={(swiper) => {
                            swiper.navigation.update(); // Extra safeguard
                          }}
                          breakpoints={{
                            0: { slidesPerView: 1 },
                            768: { slidesPerView: 2 },
                            992: { slidesPerView: 3 },
                            1366: { slidesPerView: 3 },
                          }}
                          className='product-swiper open-up'
                          data-aos="zoom-out"
                        >
                          {categories.map(category => (
                            <SwiperSlide key={category.id}>
                              <div key={category.id} className="image-zoom-effect link-effect">
                                <div className="cat-item image-zoom-effect">
                                  <div className="image-holder">
                                    <Link to='#'>
                                      <img src={category.avatarBase64} alt={category.name} className="product-image img-fluid" />
                                    </Link>
                                  </div>
                                  <div className="category-content">
                                    <div className="product-button">
                                      <Link to='#' className="btn btn-common text-uppercase">
                                        {category.name}
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                        <button className="icon-arrow icon-arrow-right" ref={prevRef} aria-label="Next categories" title="Next categories">
                          <ArrowRightIcon />
                        </button>
                        <button className="icon-arrow icon-arrow-left" ref={nextRef} aria-label="Previous categories" title="Previous categories">
                          <ArrowLeftIcon />
                        </button>
                        
                        </>
                      )
                    }
                  </>
                )
              }


          </Row>
        </Container>
      </Container>
    </Container>
  );
};
  
  export default Categories;